import { MotionValue, motion } from "framer-motion";
import { useScroll, useTransform } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import Lenis from 'lenis';

type YoutubeType = {
    title: string;
    description: string;
    link: string;
    src: string;
};

type YoutubeMobileProps = {
    youtubes: YoutubeType[];
};


export default function YoutubeMobile({ youtubes }: YoutubeMobileProps) {


    const container = useRef<HTMLElement | null>(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start start", "end end"]
    })

    useEffect(() => {
        const lenis = new Lenis()

        function raf(time: number) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }

        requestAnimationFrame(raf)
    }, [])
    const height = `${youtubes.length * 400 + 1000}px`;
    return (
        <section ref={container} className="relative md:hidden"
            style={{ height }}
        >
            <Section2 scrollYProgress={scrollYProgress} />

            {youtubes.map((youtube, i) => (
                <Section1 key={`section_${i}`} numb={i} youtube={youtube} scrollYProgress={scrollYProgress} />
            ))}
        </section>
    );
}

const Section1 = ({ youtube, scrollYProgress }: { numb: number, youtube: YoutubeType, scrollYProgress: MotionValue<number> }) => {

    return (
        <motion.div className={`sticky top-0  h-[400px] w-screen flex justify-center`}>
            <a href={youtube.link} className="w-[340px] h-[400px]">
                <img className="w-full h-full object-contain" src={`/assets/images/youtube/${youtube.src}`} width={400} height={400} alt={youtube.title} />
            </a>
        </motion.div>
    )
}


const Section2 = ({ scrollYProgress }: { scrollYProgress: MotionValue<number> }) => {


    return (
        <motion.div className="sticky top-0 h-[400px] w-screen bg-smoke">
            <div className="mx-center flex items-center justify-center h-full">
                <h2 className="text-6xl lg:text-9xl border border-lemone p-[7px] !pr-0 font-nebulica font-semibold text-[#fff]">YOU<span className="bg-lemone text-smoke">TUBE</span></h2>
            </div>
        </motion.div>
    )
}
